export default __webpack_public_path__ + "static/media/iacst-img.4e248f3e.png";